import { z } from "zod";

// Response DTO schema
export const DayOffDTOSchema = z.object({
    id: z.number().int().positive(),
    user_id: z.number().int().positive(),
    name: z.string().nullable(),
    start: z.string().datetime(),
    end: z.string().datetime().nullable(),
});

export type DayOffDTO = z.infer<typeof DayOffDTOSchema>;

// Form schema - used for real-time validation in forms
export const DayOffFormSchema = z
    .object({
        name: z
            .string()
            .max(255, "Name cannot exceed 255 characters")
            .optional()
            .default(""),
        start: z.string().min(1, "Start date is required"),
        end: z.string().optional().default(""),
    })
    .refine(
        (data) => {
            if (!data.end) return true;
            return new Date(data.end) >= new Date(data.start);
        },
        {
            message: "End date must be after start date",
            path: ["end"],
        },
    );

export type DayOffFormData = z.infer<typeof DayOffFormSchema>;

// Request schemas - mirrors Laravel validation rules (for API calls)
export const StoreDayOffRequestSchema = z.object({
    start: z.string().datetime({ message: "Start must be a valid date" }),
    end: z
        .string()
        .datetime({ message: "End must be a valid date" })
        .nullable()
        .optional(),
    name: z
        .string()
        .max(255, "Name cannot exceed 255 characters")
        .nullable()
        .optional(),
});

export type StoreDayOffRequest = z.infer<typeof StoreDayOffRequestSchema>;

export const UpdateDayOffRequestSchema = StoreDayOffRequestSchema;

export type UpdateDayOffRequest = z.infer<typeof UpdateDayOffRequestSchema>;
